import React from 'react';

export enum StatusColorEnum {
  active = 'active',
  inactive = 'inactive'
}
type Props = {
  status: StatusColorEnum;
  className?: string;
  wrapperClassName?: string;
};

const badgeColor = {
  inactive: 'text-[#FF0000]/90 bg-[#FF0000]/10',
  active: 'text-[#3FB827] bg-[#3FB827]/10'
};

const StatusColor = ({ status, className, wrapperClassName }: Props) => {
  return (
    <span
      className={`inline-flex h-fit items-center justify-center  p-1 px-3 text-xs rounded-2xl ${
        badgeColor?.[status as keyof typeof badgeColor] ?? 'text-purple] bg-purple/10'
      } ${wrapperClassName}`}>
      <span className={`text-center capitalize font-medium ${className}`}>{status}</span>
    </span>
  );
};

export default StatusColor;
